import { STATUS_TYPE } from '../../../enum';
import { Country } from '../../country/api/interface';
import { Flavor } from '../../flavor/api/interface';
import { PromoCode } from '../../promoCode/api/interface';
import { Region } from '../../region/api/interface';
import { Shape } from '../../shape/api/interface';
// import { ToppingsCategoryItem } from '../../toppingsCategoryItem/api/interface';

export interface ToppingsCategoryItem {
  id: string;
  labelAr: string;
  labelEn: string;
  previewUrl: string;
  topping_category?: {
    id: string;
    labelEn: string;
    labelAr: string;
  };
  toppingShapeImages: {
    id: string;
    shapeId: string;
    sliced: string;
    top: string;
    front: string;
  }[]
}
export interface OrderItems {
  id: string;
  qty: string;
  unitPrice: string;
  orderCakeId: string | null;
  addonProductVariantId: string | null;
  order_cake: {
    id: string;
    shapeLabelEn: string;
    shapeLabelAr: string;
    flavorLabelEn: string;
    flavorLabelAr: string;
    colorCode: string;
    flavorId: string;
    shapeId: string;
    toppingId: string;
    flavor: Flavor;
    shape: Shape;
    topping_category_item: ToppingsCategoryItem;
    category_cake?: {
      id: string;
      labelEn: string;
      labelAr: string;
    };
    displayMode: string;
    writeOnCake: string;
    printImageUrl: string;
  } | null;
  addon_product_variant: {
    id: string;
    labelEn: string;
    labelAr: string;
    previewUrl: string;
    price: string;
  } | null;
  addon_product: {
    id: string;
    labelEn: string;
    labelAr: string;
    previewUrl: string;
    price: string;
  } | null;
}

export interface FindOrder {
  status?: string | string[];
  paymentStatus?: string;
  orderDate?: string;
  isExport?: boolean;
  limit?: number;
  skip?: number;
  search?: string;
}

export interface GetOrder {
  id: string;
}

export interface Order {
  id: string;
  orderNumber: string;
  orderDate: string;
  status: string;
  totalAmount: number;
  promoCodeDiscountAmount: number;
  vatAmount: number;
  deliveryFee: number;
  isIdentitySecret: boolean;
  exactDeliverySlot?: string | null;
  exactDeliverySlotDate?: string | null;
  cardMessage: string;
  shippingAddress: {
    id: string;
    area: string;
    floor: string;
    addressName: string;
    street: string;
    userId: string;
    latitude: boolean;
    regionId: string;
    countryId: string;
    createdAt: string;
    isDefault: boolean;
    longitude: string;
    updatedAt: string;
    postalCode: string;
    activeState: boolean;
    addressType: string;
    houseNumber: string;
    officeNumber: string;
    buildingNumber: string;
    extraDirection: string;
    apartmentNumber: string;
    region: Region;
    country: Country;
  }
  deliveryDate: {
    amount: number;
    paymentMethod: string;
  }
  additionalInfo: any;
  userDetails: {
    id: string;
    firstName: string;
    lastName: string;
    mobileNumber: string;
    email: string;
    region: Region;
  }
  country_payment_method: {
    id: string;
    labelEn: string;
    labelAr: string;
    code: string;
  }
  payment: any;
  promo_code_usage: {
    id: string;
    orderId: string;
    usageDate: string;
    promoCodeId: string;
    promo_code: PromoCode;
    // discountAmount: string;
    // discountType: string;
  }
  order_items: OrderItems[];
  createdAt: Date;
  updatedAt: Date;
  createdBy: string;
  updatedBy: string;
  createdByUser?: string;
  updatedByUser?: string;
}

export interface InitialState {
  data: Order[];
  skip: number;
  limit: number;
  totalRecords: number;
  currentPage: number;
  status: STATUS_TYPE;
  isError: boolean;
  isLoading: boolean;
  isSuccess: boolean;
  errorMessage: string;
}

export const initialState: InitialState = {
  data: [],
  skip: 0,
  limit: 25,
  totalRecords: 0,
  currentPage: 0,
  status: 'idle',
  isError: false,
  isLoading: false,
  isSuccess: false,
  errorMessage: '',
};
